import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuildService } from '../core/service/form-build.service';
import { FormCoreModule } from '../core/form-core.module';
import { AppCoreModule } from '../../core/app-core.module';

import { TestaTemplateComponent } from './testa-template/testa-template.component';
import { TestbTemplateComponent } from './testb-template/testb-template.component';
import { CommerceLoginTemplateComponent } from './commerce-login-template/commerce-login-template.component';
import { CommerceGeneralTemplateComponent } from './commerce-general-template/commerce-general-template.component';
import { CommerceFinancesTemplateComponent } from './commerce-finances-template/commerce-finances-template.component';
import { CommerceVerificationTemplateComponent } from './commerce-verification-template/commerce-verification-template.component';
import { AddressTemplateComponent } from './address-template/address-template.component';

@NgModule({
  imports: [
    CommonModule,
    FormCoreModule,
    AppCoreModule,
  ],
  declarations: [
    TestaTemplateComponent,
    TestbTemplateComponent,
    CommerceLoginTemplateComponent,
    CommerceGeneralTemplateComponent,
    CommerceFinancesTemplateComponent,
    CommerceVerificationTemplateComponent,
    AddressTemplateComponent,
  ],
  entryComponents: [
    TestaTemplateComponent,
    TestbTemplateComponent,
    CommerceLoginTemplateComponent,
    CommerceGeneralTemplateComponent,
    CommerceFinancesTemplateComponent,
    CommerceVerificationTemplateComponent,
    AddressTemplateComponent,
  ],
  exports: [
    TestaTemplateComponent,
    TestbTemplateComponent,
    CommerceLoginTemplateComponent,
    CommerceGeneralTemplateComponent,
    CommerceFinancesTemplateComponent,
    CommerceVerificationTemplateComponent,
    AddressTemplateComponent,
  ]
})
export class FormTemplateModule {
  constructor(private formBuildService: FormBuildService) {
    this.formBuildService.addComponent('testa', TestaTemplateComponent);
    this.formBuildService.addComponent('testb', TestbTemplateComponent);
    this.formBuildService.addComponent('address', AddressTemplateComponent);

    this.formBuildService.addComponent('commerce-login', CommerceLoginTemplateComponent);
    this.formBuildService.addComponent('commerce-general', CommerceGeneralTemplateComponent);
    this.formBuildService.addComponent('commerce-finances', CommerceFinancesTemplateComponent);
    this.formBuildService.addComponent('commerce-verification', CommerceVerificationTemplateComponent);

  }
}



// WEBPACK FOOTER //
// ./src/app/form/template/template.module.ts